import { render, staticRenderFns } from "./QueueSetup.vue?vue&type=template&id=6de19374&"
import script from "./QueueSetup.vue?vue&type=script&lang=js&"
export * from "./QueueSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports